import Group from "./images/class_group.jpg";
const courses = [
    {
        img:Group,
        title:"JEE Mains/Advanced",
        desc:"Joint Entrance Examination (JEE) is an engineering entrance exam conducted for admission to various engineering colleges in India. It is constituted by two ...",
        link:"./jee"
    },
    {
        img:Group,
        title:"NEET-UG",
        desc:"NEET (UG), is an all India pre-medical entrance test for students who wish to pursue undergraduate medical (MBBS), dental (BDS) courses in gover ...",
        link:"./neet"
    },
    {
        img:Group,
        title:"MHT-CET",
        desc:"The MHT-CET or Common Entrance Test is an annual entrance exam conducted by the Government of Maharashtra.he degree courses of the following ...",
        link:"./cet"
    },
    {
        img:Group,
        title:"NATA",
        desc:"National Aptitude Test in Architecture (NATA) is conducted by National Institute of Advanced Studies in Architecture (NIASA).It is a national level examination ...",
        link:"./nata"
    }
];

export default courses;
